import backIcon from "../../../assets/images/arrow-up.svg";
import exploreIcon from "../../../assets/images/explore.svg";
import myFeedIcon from "../../../assets/images/my-feed.svg";
import bookmarkIcon from "../../../assets/images/bookmark-thick.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalStorage } from "../../../utils/localStorage";
import { FROM_TATAV_PRACTICE } from "../../../utils/constants";
import { navigateToTatvaPractice } from "../../../utils/helper";
import { trackZymedEvent, ZYMED_EVENTS } from "../../../utils/zymedAnalytics";

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const handleHomeNavigation = () => {
    const fromPractice = getLocalStorage(FROM_TATAV_PRACTICE);
    if (fromPractice && fromPractice === "true") {
      navigateToTatvaPractice()
    } else {
      navigate("/")
    }
  }

  const trackNav = (tab_name: string) =>
    trackZymedEvent(ZYMED_EVENTS.SHOTS_BOTTOM_NAV_CLICKED, { tab_name });

  return (
    <div className="flex justify-between px-4 py-2 h-[64px] w-full text-xs max-w-[1280px] fixed bottom-0 z-10 bg-white">
      <div
        className={`flex flex-col justify-center items-center flex-1 pr-2 border-r border-black border-opacity-10 ${isActive("/") ? "text-indigo-600 font-semibold" : "text-zinc-700"
          }`}
        role="button"
        aria-label="Go to Home"
        onClick={() => { trackNav("Home"); handleHomeNavigation(); }}
      >
        <img
          loading="lazy"
          src={backIcon}
          alt="Home Icon"
          className="object-contain w-6 aspect-square"
        />
        <div className="mt-1 font-semibold whitespace-nowrap">Home</div>
      </div>

      <div
        className={`flex flex-col justify-center items-center flex-1 ${isActive("/tatva-shots-home")
          ? "text-indigo-600 font-semibold"
          : "text-zinc-700"
          }`}
        role="button"
        aria-label="Go to Discover"
        onClick={() => { trackNav("Discover"); navigate("/tatva-shots-home"); }}
      >
        <img
          loading="lazy"
          src={exploreIcon}
          alt="Explore Icon"
          className="object-contain w-6 aspect-square"
        />
        <div className="mt-1 whitespace-nowrap">Discover</div>
      </div>

      <div
        className={`flex flex-col justify-center items-center flex-1 ${isActive("/short") ? "text-indigo-600 font-semibold" : "text-zinc-700"
          }`}
        role="button"
        aria-label="Go to My Feed"
        onClick={() => { trackNav("My Feed"); navigate("/short", { state: { type: "myFeed" } }); }}
      >
        <img
          loading="lazy"
          src={myFeedIcon}
          alt="My Feed Icon"
          className="object-contain w-6 aspect-square"
        />
        <div className="mt-1 whitespace-nowrap">My Feed</div>
      </div>

      <div
        className={`flex flex-col justify-center items-center flex-1 ${isActive("/short") ? "text-indigo-600 font-semibold" : "text-zinc-700"
          }`}
        role="button"
        aria-label="Go to Bookmarks"
        onClick={() => {
          trackNav("Bookmarks");
          trackZymedEvent(ZYMED_EVENTS.SHOTS_VISIT_BOOKMARKS);
          navigate("/short", { state: { type: "bookmarks" } });
        }}
      >
        <img
          loading="lazy"
          src={bookmarkIcon}
          alt="Bookmarks Icon"
          className="object-contain w-6 aspect-square"
        />
        <div className="mt-1 whitespace-nowrap">Bookmarks</div>
      </div>
    </div>
  );
}
